import React from "react";

export default function UsersSummaryBar({
  stats,
  filters,
  roleOptions,
  displayedCount,
  page,
  pageCount,
  loading,
}) {
  const selectedRoleLabel =
    roleOptions.find(
      (role) =>
        role.id ===
        filters.selectedRole,
    )?.label;

  return (
    <div className="mt-4 flex flex-wrap items-center gap-2 text-sm text-slate-500 dark:text-slate-400">
      <span className="rounded-full bg-slate-100 px-3 py-1 dark:bg-slate-800">
        {stats.totalUsers} utilisateur
        {stats.totalUsers > 1
          ? "s"
          : ""}
      </span>

      <span className="rounded-full bg-slate-100 px-3 py-1 dark:bg-slate-800">
        {stats.totalActeurs} acteur
        {stats.totalActeurs > 1
          ? "s"
          : ""}
      </span>

      <span className="rounded-full bg-slate-100 px-3 py-1 dark:bg-slate-800">
        {stats.totalBadges} badge
        {stats.totalBadges > 1
          ? "s"
          : ""}
      </span>

      {filters.selectedRole ? (
        <span className="rounded-full bg-indigo-50 px-3 py-1 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300">
          Rôle : {selectedRoleLabel}
        </span>
      ) : null}

      {filters.debouncedSearch ? (
        <span className="rounded-full bg-indigo-50 px-3 py-1 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300">
          Recherche :{" "}
          {filters.searchTerm}
        </span>
      ) : null}

      {filters.recentFilter ? (
        <span className="rounded-full bg-indigo-50 px-3 py-1 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300">
          Filtre date actif
        </span>
      ) : null}

      {filters.coachBadgePrintedFilter ? (
        <span className="rounded-full bg-blue-50 px-3 py-1 text-blue-700 dark:bg-blue-500/10 dark:text-blue-300">
          Imprimé :{" "}
          {filters.coachBadgePrintedFilter ===
          "true"
            ? "Oui"
            : "Non"}
        </span>
      ) : null}

      {filters.coachBadgeReceivedFilter ? (
        <span className="rounded-full bg-emerald-50 px-3 py-1 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300">
          Réceptionné :{" "}
          {filters.coachBadgeReceivedFilter ===
          "true"
            ? "Oui"
            : "Non"}
        </span>
      ) : null}

      {!loading &&
      stats.totalUsers > 0 ? (
        <span className="ml-auto text-xs">
          Affichage {displayedCount} •
          page {page} / {pageCount}
        </span>
      ) : null}
    </div>
  );
}